import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import { base_url } from '../../Api/Api';
import Skltn from './skltnInnerWebinar';

const InnerWebinar = (props) => {

    const [state, setState] = useState({
        data: [],
        loader: true
    })

    useEffect(() => {

        window.scrollTo(0, 0)

        base_url.get(`webinar/${props.match.params.id}`)
            .then(response => {
                setState({
                    ...state,
                    data: response.data,
                    loader: false
                })
            })
            .catch(error => {
                if (error.response != undefined) {
                    if (error.response.status == 401) {
                        props.history.push(`/Entrance`)
                        localStorage.clear()
                        window.location.reload()
                    }
                }
            })

    }, [])
    return (
        <>
            {state.data.length == 0 ?
                <Skltn />
                :
                <div className="innerWebinar">
                    <div className="contain">
                        <div className="inner-body">
                            <div className="backward">
                                <span onClick={() => props.history.goBack()}>بازگشت <i className="icon-arrow-down-sign-to-navigate-fill"></i></span>
                            </div>
                            <div className="body">
                                <h6>
                                    {state.data.title}
                                    <span>
                                        <b>امتیاز این وبینار : </b>
                                        <i className="icon-black-star-silhouette"></i>
                                        {state.data.score}
                                    </span>

                                </h6>

                                <div className="picture">
                                    <img src={state.data.original_image} />
                                </div>
                                <div className="time">
                                    <span>تاریخ شروع: <b>{state.data.string_starttime}</b></span>
                                    <span>زمان برگزاری: <b>{state.data.string_eventtime}</b></span>
                                    <span>تاریخ پایان: <b>{state.data.string_enddate}</b></span>
                                    <span>زمان پایان: <b>{state.data.string_endtime}</b></span>
                                </div>
                                <span className="about">درباره وبینار : </span>
                                <p>{state.data.description}</p>
                                <div className="tags all-styless">
                                    {state.data.tags.length == 0 ? null : state.data.tags.map(info =>
                                        <span>{info.name}</span>
                                    )}
                                </div>
                                <div className="btn">
                                    <a href={state.data.url} target="_blank">
                                        <Button
                                            variant="contained">ورود به کلاس</Button>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </>
    );
}

export default InnerWebinar;